import { memo, useLayoutEffect } from "react";
import { ActivityIndicator, ScrollView } from "react-native";
import { Stack, useNavigation } from "expo-router";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { View } from "@src/components/View";
// @ts-expect-error baseline 2026-02-16
import { WebLayout } from "@src/components/web";
import { isWeb } from "@src/utils/web-helpers";
import { useHeaderBackButton } from "@src/hooks/useHeaderBackButton";
import { InviteUserForm, useInviteUserFormState } from "@visioni/a3s-access/app";
import { useInviteUserPage } from "@src/features/settings/hooks";

const InviteUserScreen = memo(() => {
  const { theme } = useUnistyles();
  const navigation = useNavigation();
  const { headerLeft } = useHeaderBackButton();

  const { siteList, cameraList, isLoading, isPending, handleSubmit, handleCancel } = useInviteUserPage();

  const {
    email,
    emailError,
    permissionsError,
    tenantAdmin,
    siteSelection,
    cameraSelection,
    handleEmailChange,
    handleTenantAdminToggle,
    handleSiteToggle,
    handleSiteRoleChange,
    handleCameraToggle,
    handleCameraRoleChange,
    handleSubmit: handleFormSubmit,
  } = useInviteUserFormState({ onSubmit: handleSubmit });

  useLayoutEffect(() => {
    navigation.setOptions({
      title: "Invite User",
      headerLeft,
      headerStyle: {
        backgroundColor: theme.colors.background,
      },
    });
  }, [navigation, theme.colors.background, headerLeft]);

  if (isLoading) {
    if (isWeb) {
      return (
        <>
          <Stack.Screen options={{ headerShown: false }} />
          <WebLayout>
            <View style={styles.centered}>
              <ActivityIndicator />
            </View>
          </WebLayout>
        </>
      );
    }
    return (
      <View style={styles.centered}>
        <ActivityIndicator />
      </View>
    );
  }

  if (isWeb) {
    return (
      <>
        <Stack.Screen options={{ headerShown: false }} />
        <WebLayout>
          <ScrollView style={styles.scrollView} contentContainerStyle={styles.contentContainerStyle}>
            <View style={styles.formContainer}>
              <InviteUserForm
                email={email}
                emailError={emailError}
                permissionsError={permissionsError}
                tenantAdmin={tenantAdmin}
                sites={siteList}
                cameras={cameraList}
                siteSelection={siteSelection}
                cameraSelection={cameraSelection}
                isPending={isPending}
                onEmailChange={handleEmailChange}
                onTenantAdminToggle={handleTenantAdminToggle}
                onSiteToggle={handleSiteToggle}
                onSiteRoleChange={handleSiteRoleChange}
                onCameraToggle={handleCameraToggle}
                onCameraRoleChange={handleCameraRoleChange}
                onSubmit={handleFormSubmit}
                onCancel={handleCancel}
              />
            </View>
          </ScrollView>
        </WebLayout>
      </>
    );
  }

  return (
    <ScrollView style={styles.scrollView} contentContainerStyle={styles.contentContainerStyle}>
      <InviteUserForm
        email={email}
        emailError={emailError}
        permissionsError={permissionsError}
        tenantAdmin={tenantAdmin}
        sites={siteList}
        cameras={cameraList}
        siteSelection={siteSelection}
        cameraSelection={cameraSelection}
        isPending={isPending}
        onEmailChange={handleEmailChange}
        onTenantAdminToggle={handleTenantAdminToggle}
        onSiteToggle={handleSiteToggle}
        onSiteRoleChange={handleSiteRoleChange}
        onCameraToggle={handleCameraToggle}
        onCameraRoleChange={handleCameraRoleChange}
        onSubmit={handleFormSubmit}
        onCancel={handleCancel}
      />
    </ScrollView>
  );
});

export default InviteUserScreen;

const styles = StyleSheet.create((theme) => ({
  scrollView: {
    flex: 1,
  },
  contentContainerStyle: {
    flexGrow: 1,
    padding: theme.spacing["3xl"],
  },
  formContainer: {
    maxWidth: 800,
    width: "100%",
  },
  centered: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
}));
